import { render } from "./DropdownSelect.vue?vue&type=template&id=349b6a79"
import script from "./DropdownSelect.vue?vue&type=script&lang=js"
export * from "./DropdownSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__